import { render, staticRenderFns } from "./zoneCard.vue?vue&type=template&id=49d86812&scoped=true&"
import script from "./zoneCard.vue?vue&type=script&lang=js&"
export * from "./zoneCard.vue?vue&type=script&lang=js&"
import style0 from "./zoneCard.vue?vue&type=style&index=0&id=49d86812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d86812",
  null
  
)

export default component.exports